import moment from "moment";

export const formatDate = (dateString: string) => {
  try {
    return moment(dateString).format("D MMM YYYY h:mm A");
  } catch {}
  return "";
};
